export enum ContactInfluenceDegree {
  INFLUENCER = 'INFLUENCER',
  USER = 'USER',
  DECIDER = 'DECIDER',
  BUYER = 'BUYER'
}
